
(function() {
  // Prüfen, ob passive Event Listener unterstützt werden
  var supportsPassive = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function() {
        supportsPassive = true;
      }
    });
    window.addEventListener("testPassive", null, opts);
    window.removeEventListener("testPassive", null, opts);
  } catch (e) {}

  var hotjarLoaded = false;

  function loadHotjar() {
    if (hotjarLoaded) return;

    // Optional: Consent prüfen (nur wenn du ein CMP nutzt)
    // if (!window.userHasConsentedToHotjar) return;

    hotjarLoaded = true;

    var hotjarScript = document.getElementById("hotjar-script");

    if (!hotjarScript) {
      hotjarScript = document.createElement("script");
      hotjarScript.type = "text/javascript";
      hotjarScript.id = "hotjar-script";
      hotjarScript.innerHTML = `
        (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:3754942,hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `;
      document.body.appendChild(hotjarScript);
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Interaktionen triggern Hotjar-Load
    window.addEventListener("scroll", loadHotjar, supportsPassive ? { passive: true } : false);
    document.addEventListener("touchstart", loadHotjar, supportsPassive ? { passive: true } : false);
    document.addEventListener("click", loadHotjar, supportsPassive ? { passive: true } : false);

    // Fallback: Nach 10 Sekunden automatisch laden
    setTimeout(loadHotjar, 10000);
  });
})();
